module.exports = __webpack_public_path__ + "static/media/dasboardbank2.09156540.png";